import React from "react";
import styled from "styled-components";

const mockAssets = [
  {
    name: "Unternehmenspraesentation.pdf",
    type: "Dokument",
    status: "Freigegeben"
  },
  {
    name: "Onboarding-Ablauf.png",
    type: "Bild",
    status: "In Vorbereitung"
  },
  {
    name: "Leistungsumfang_TrackCode.docx",
    type: "Dokument",
    status: "Freigegeben"
  }
];

const Management = () => {
  return (
    <Container>
      <Header>
        <Title>Management</Title>
        <Description>
          Hier koennen Leads und Neukunden strukturiert Inhalte erhalten - fuer
          einen professionellen Einstieg in die TrackCode Plattform.
        </Description>
      </Header>

      <Card>
        <SectionTitle>Bereitgestellte Inhalte</SectionTitle>
        <AssetList>
          {mockAssets.map(asset => (
            <AssetItem key={asset.name}>
              <AssetMeta>
                <AssetName>{asset.name}</AssetName>
                <AssetType>{asset.type}</AssetType>
              </AssetMeta>
              <AssetStatus>{asset.status}</AssetStatus>
            </AssetItem>
          ))}
        </AssetList>
      </Card>
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  padding: 24px;
  background: #f5f6f8;
  overflow: auto;
`;

const Header = styled.div`
  margin-bottom: 20px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  color: #20232a;
`;

const Description = styled.p`
  margin-top: 8px;
  color: #4e5563;
  max-width: 720px;
`;

const Card = styled.section`
  background: #fff;
  border: 1px solid #e4e6eb;
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  max-width: 860px;
`;

const SectionTitle = styled.h2`
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #20232a;
`;

const AssetList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AssetItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff3;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fafbfc;
`;

const AssetMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const AssetName = styled.span`
  color: #20232a;
  font-weight: 600;
`;

const AssetType = styled.span`
  color: #6f7787;
  font-size: 12px;
`;

const AssetStatus = styled.span`
  color: #175e36;
  font-size: 12px;
  font-weight: 600;
  background: #e8f6ef;
  border-radius: 999px;
  padding: 4px 10px;
`;

export default Management;
